import React, { useCallback } from 'react';
import { clsx } from 'clsx';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isSet } from '@/utils';
import ConditionalFragment from '@/components/common/ConditionalFragment';
import Flexbox from '@/components/common/Flexbox';
export const Amount: React.FC<{
  value: number;
  onChange: (value: number) => void;
  className?: string;
  maximum?: number;
  minimum?: number;
  unit?: string;
}> = ({
  value,
  onChange,
  className,
  maximum = 99,
  minimum = 1,
  unit
}) => {
  const onIncrease = useCallback(() => {
    if (value >= maximum) return;
    onChange(value + 1);
  }, [value, onChange, maximum]);
  const onDecrease = useCallback(() => {
    if (value <= minimum) return;
    onChange(value - 1);
  }, [value, onChange, minimum]);
  return <Flexbox align={'center'} justify={'between'} className={clsx(className, 'bg-white rounded')} data-sentry-element="Flexbox" data-sentry-component="Amount" data-sentry-source-file="Amount.tsx">
      <Flexbox as={'button'} type={'button'} onClick={onDecrease} align={'center'} justify={'center'} className={'w-12 h-12 disabled:text-grey4'} disabled={value <= minimum} data-sentry-element="Flexbox" data-sentry-source-file="Amount.tsx">
        <FontAwesomeIcon icon={faMinus} className={'w-2'} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="Amount.tsx" />
      </Flexbox>
      <div className={'flex-1 text-fz5/text text-center truncate'}>
        {value}
        <ConditionalFragment condition={isSet(unit)} data-sentry-element="ConditionalFragment" data-sentry-source-file="Amount.tsx">
          {' '}
          {unit}
        </ConditionalFragment>
      </div>
      <Flexbox as={'button'} type={'button'} onClick={onIncrease} align={'center'} justify={'center'} className={'w-12 h-12 disabled:text-grey4'} disabled={maximum <= value} data-sentry-element="Flexbox" data-sentry-source-file="Amount.tsx">
        <FontAwesomeIcon icon={faPlus} className={'w-2'} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="Amount.tsx" />
      </Flexbox>
    </Flexbox>;
};